const DepartmentEnum = {
    technical: { id: 1, name: "მომეტებული ტექნიკური საფრთხის შემცველი ობიექტების ზედამხედველობის სამმართველო" },
    building: { id: 2, name: "განსაკუთრებული ობიექტების მშენებლობის ნებართვებისა და ზედამხედველობის სამმართველო" },
    legal: { id: 3, name: "სამართლებრივი უზრუნველყოფის სამმართველო" },
    administration: { id: 4, name: "ადმინისტრირებისა და ინფორმაციული უზრუნველყოფის სამმართველო" },

};
export default DepartmentEnum